import { storeStructure } from '../store/reducers';
import formGroupLiveAppComposeExperience from './formGroupLiveApps/form1GroupLiveAppComposeExperience';
import formGroupLiveAppConfigContent from './formGroupLiveApps/form2GroupLiveAppConfigContent';
import formGroupLiveAppSportRoomConfigContent from './formGroupLiveApps/form3GroupLiveAppSportRoomConfigContent';
import formGroupLiveAppStatus from './formGroupLiveApps/form0GroupLiveAppStatus';
import formGroupLiveAppManager from './formGroupLiveApps/form4GroupLiveAppManager';


export default {
  title: 'Live App Contents',
  attributeName: 'liveappcontents',
  // createURL: 'live/logs',
  sessionParams: [],
  getURL: 'live/apps',
  updateURL: 'live/apps',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  saveIdSessionNameAs: 'liveId',
  formConfig: [
    formGroupLiveAppStatus,
    formGroupLiveAppComposeExperience,
    formGroupLiveAppConfigContent,
    formGroupLiveAppSportRoomConfigContent,
    formGroupLiveAppManager,
  ],
};
